import { Component, Input, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { AccountingService } from 'src/app/configurations/integration/accounting/accounting.service';

@Component({
  selector: 'app-pos-details',
  templateUrl: './pos-details.component.html',
  styleUrls: ['./pos-details.component.scss']
})
export class PosDetailsComponent   {
  products=[];
  selectedProduct;
  @Input() selectedData ; 
  @Input() posConsumerId;
  @Input() vendorName;
  noPosDetailsFindOrLoadingText: string = 'Loading...';
  totalRecord: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  first: number = 0;
  rowsPerPage = [15, 30, 50, 100];
  storeId:number = 0;
  display = false;
  posView :{};


    constructor( private integratonService: AccountingService,public appMainService: AppMainService,
    private messageService: MessageService,
    ) { }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedData && changes.selectedData.currentValue) {
    this.storeId = this.selectedData.posStoreInfo.storeId
    this.getPosVendordetails(this.vendorName,this.posConsumerId,this.storeId);
    }
  }
  

  onClose() {
    this.display = false;
  }

  onRowSelect($event) {
    this.display = true;
    this.posView = $event.data;
  }

  getPosDetailsData(event) {
    this.pageNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.first = event.first;
    this.getPosVendordetails(this.vendorName,this.posConsumerId,this.storeId)
  }


  getPosVendordetails(vendorName,posConsumerId,storeId){
    this.appMainService.isShowSpinner('posListing');
    this.integratonService.getPosVendordetails(vendorName,posConsumerId,storeId,this.pageNumber, this.pageSize).subscribe({
      next: (response) => {
       this.appMainService.isHideSpinner('posListing');
       let { posDetails, headers } = response;

      posDetails = !posDetails ? [] : posDetails;
      headers = !headers  ? [] : headers;
       
       this.totalRecord = headers["TotalCount"];
       this.products = [];
       if (posDetails.length > 0) {
         this.products = posDetails;
         this.appMainService.isHideSpinner('posListing');
       } else {
         this.noPosDetailsFindOrLoadingText = "No Pos found.";
         this.products = [];
         this.appMainService.isHideSpinner('posListing');
       }

      },
      error: (error) => {
        this.products = [];
        this.totalRecord = 0;
        this.pageNumber = 1;
        this.pageSize= 15;
      this.appMainService.isHideSpinner('posListing');
      this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error.Title}` });
      },
      complete: () => {
        this.appMainService.isHideSpinner('posListing');
      }
    });
  }
}
